module.exports = __webpack_public_path__ + "static/media/green-star.01df53ce.svg";